var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-layout',{attrs:{"leftBannerList":_vm.leftBannerList,"rightBannerList":_vm.rightBannerList,"navLeftList":_vm.navLeftList,"navRightList":_vm.navRightList,"hotList":_vm.hotList,"hotShowList":_vm.hotShowList},on:{"preview":_vm.preview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }